'use strict';

var Master = require('./master.js');


/**
 * Creates a Master Layout
 *
 * @implements {Layout}
 * @param {String} [target=body] - Selector string that defines the target
 * @returns {Master}
 * @exports LayoutCircuits
 */

var MasterCircuits = function(target, noNav){
	return new Master({
		target: target,
		fields: {
			'noNav': noNav
		}
	});
}

module.exports = MasterCircuits;